import React from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';

const Store: React.FC = () => {
  return (
    <Container className="py-5 text-center">
      <h1 className="text-navy fw-bold mb-4">Team Store</h1>
      <p className="lead mb-5">Order your uniforms, training gear, and fan apparel.</p>

      <Row className="justify-content-center mb-5">
        <Col md={8} lg={6}>
          <Card className="shadow-lg border-0">
            <Card.Body className="p-5 text-center">
              <h3 className="mb-4">Access Code Required</h3>
              
              <Alert variant="info" className="d-inline-block px-5 py-3 mb-4">
                <span className="text-muted small d-block mb-1">STORE PASSWORD</span>
                <span className="display-6 fw-bold text-navy">SOC2025</span>
              </Alert>

              <p className="mb-4 text-muted">
                Please copy the password above before entering the store.
              </p>

              <Button 
                variant="primary" 
                size="lg" 
                href="https://www.aretyn.store/515-soccer-academy" 
                target="_blank" 
                className="px-5 py-3 fw-bold w-100"
              >
                Enter Store
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center text-start">
        <Col md={10} lg={8}>
          <Card className="border-0 shadow-sm bg-light p-4 mb-4">
            <h4 className="text-navy fw-bold mb-3">How to Order</h4>
            <ol className="mb-0">
              <li className="mb-2">Click the <strong>"Enter Store"</strong> button above and enter the password: <code className="fw-bold">SOC2025</code></li>
              <li className="mb-2">Navigate to the <strong>"515 Soccer Academy Required Player Package"</strong> section.</li>
              <li className="mb-2">Select your <strong>team</strong> and <strong>player's name</strong> from the dropdown menus.</li>
              <li className="mb-2 text-danger fw-bold">
                Verify the Player Number: Ensure the number displayed next to the player's name is correct before checking out.
              </li>
              <li className="mb-0">Complete your checkout. You can add extra tops, shorts, or socks during this process by increasing the quantities.</li>
            </ol>
          </Card>

          <div className="px-4 py-2">
            <h5 className="text-navy fw-bold">Uniform Kit Details</h5>
            <p className="mb-2 text-muted">
              The full player package is approximately <strong>$130</strong> and includes two full kits (two tops, two pairs of shorts, and two pairs of socks) designed to be mixed and matched.
            </p>
            <p className="small text-muted mb-4">
              <em>Training tops, sweatshirts, and backpacks are also available as optional items.</em>
            </p>

            <h5 className="text-navy fw-bold small">Need Help?</h5>
            <p className="small text-muted">
              If your player's number is incorrect or you have other questions, please contact Bo Schatzberg at <a href="mailto:bo@515soccer.org" className="text-teal">bo@515soccer.org</a>.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Store;
